import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import request from "./utils/request.js"
import storage from "./utils/storage.js"
Vue.prototype.$storeage = storage

// import VueMeta from 'vue-meta'
// Vue.use(VueMeta, {
//   keyName: 'metaInfo', // 组件中用来定义元信息的属性名
//   // 配置选项，例如刷新时保留标签页标题
//   refreshOnceOnNavigation: true,
// });

Vue.use(ElementUI);

Vue.config.productionTip = false


new Vue({
	router,
	request,
	el: '#app',
	render: h => h(App)
});